import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/money/`;

const verifyReceipt = async (qrString) => {
  return await axios.post(API_URL + 'verify', {qrString});
};

const MoneyService = { verifyReceipt };
export default MoneyService;